export const enum StatusType {
  ERROR = "error",
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
}

export type StatusTypes = `${StatusType}`;
